<template>
  <b-row>
    <b-col cols="12" lg="6" class="p-3">
      <div
        class="job-offer-details-card responsive-font mb-3 border_1 border_med_gray p-1 p-md-2 p-xl-3 d-flex flex-column justify-content-between align-items-center"
      >
        <div
          class="d-flex flex-column justify-content-start align-items-center"
        >
          <span class="v2_font_size_18 v2_font_weight_semibold mb-2 mt-2">
            Job Description
          </span>
          <perfect-scrollbar class="max_height_150 mb-2">
            <span class="text-center">
              {{ jobOffer.description }}
            </span>
          </perfect-scrollbar>
        </div>
        <b-button 
          v-if="!jobBoardUrlVisiable && this.jobOffer.external_url"
          variant="v3_teal_outline"
          class="mb-2" 
          @click="onJobBoardRevealUrl">
            <span class="d-inline-flex align-items-center">Click to See Job Board URL</span>
        </b-button>
        <b-button
        v-if="jobBoardUrlVisiable"
          variant="v2_link"
          class="d-inline-flex align-items-center v2_font_size_18 v2_font_weight_semibold mt-3"
          @click="onViewJobBoardClick"
        >
          <u>{{ this.jobOffer.external_url }}</u>
        </b-button>
      </div>
      <div
        class="job-offer-details-card responsive-font p-1 p-md-2 p-xl-3 v2_font_size_16"
      >
        <job-profile-job-offer-comparison
          :job-offer="fullJobOffer"
          :job-profile="jobProfile"
          :job-questions="jobQuestions"
        />
      </div>
    </b-col>
    <template v-if="isMessageView">
      <b-col cols="12" lg="6" class="p-3">
        <div
          class="job-offer-details-card border_1 border_med_gray h-100 p-2 p-xl-3"
        >
          <job-profile-message-center
            :view-mode="viewMode"
            :mode="mode"
            :match="match"
            :messages="messages"
            :is-messages-loading="isMessagesLoading"
            @mark-as-read="$emit('mark-as-read', $event)"
            @new-msg-created="$emit('new-msg-created', $event)"
            @close-message-list="$emit('close-message-list')"
            @mode-changed="$emit('mode-changed', $event)"
          />
        </div>
      </b-col>
    </template>
    <template v-else>
      <b-col cols="12" lg="6">
        <b-row class="h-100">
          <b-col cols="12" class="p-3">
            <div
              class="job-offer-details-card responsive-font border_1 border_med_gray p-1 p-md-2 p-xl-3 d-flex flex-column justify-content-between align-items-center"
            >
              <div
                class="d-flex flex-column justify-content-start align-items-center mt-2"
              >
                <span class="v2_font_size_18 v2_font_weight_semibold mb-2">
                  Messages
                </span>
                <perfect-scrollbar class="max_height_150">
                  <span class="text-center">
                    {{ jobOffer.welcome_message }}
                  </span>
                </perfect-scrollbar>
              </div>
              <b-button
                variant="v2_link"
                class="d-inline-flex align-items-center v2_font_size_18 v2_font_weight_semibold mt-3"
                @click="$emit('open-new-msg')"
              >
                <i class="mdi mdi-email-plus mr-2" /> Contact Recruiter
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </template>
  </b-row>
</template>

<script>
import Api from '@/providers/Api';
import JobProfileJobOfferComparison from '@/components/exchange/job-profiles-list/JobProfileJobOfferComparison';
import JobProfileMessageCenter from '@/components/exchange/job-profiles-list/JobProfileMessageCenter';
import { logUserEvent } from '@/helpers/LoggerHelper';
import { EVENT_PARAMETERS, EVENT_TYPES } from '@/store';
import { VIEW_MODES } from '@/components/exchange/job-profiles-list/JobProfileJobOfferListItem';

export default {
  name: 'JobProfileListItemsDetails',
  props: {
    match: Object,
    jobProfile: Object,
    viewMode: {
      type: String,
    },
    mode: {
      type: String,
    },
    messages: Array,
    isMessagesLoading: Boolean,
    jobQuestions: Array,
  },
  components: {
    JobProfileJobOfferComparison,
    JobProfileMessageCenter,
  },
  data: function () {
    return {
      jobOfferWithDetails: null,
      jobBoardUrlVisiable: false
    };
  },
  created: function () {
    this.getJobOfferDetails();
  },
  computed: {
    loaderId: function () {
      return `loading_${this.$options.name}`;
    },
    fullJobOffer: function () {
      return { ...this.jobOffer, ...(this.jobOfferWithDetails || {}) };
    },
    jobOffer: function () {
      return this.match.jobOffer || {};
    },
    isMessageView: function () {
      return [VIEW_MODES.MESSAGES, VIEW_MODES.NEW_MSG].includes(this.viewMode);
    },
  },
  methods: {
    getJobOfferDetails: async function () {
      if (!this.jobOffer || !this.jobOffer.id) return;
      this.$wait.start(this.loaderId);
      try {
        this.jobOfferWithDetails = await Api.getJobOfferDetailsForJobProfile(
          this.jobOffer.id,
          this.jobProfile.id
        );
      } finally {
        this.$wait.end(this.loaderId);
      }
    },
    onJobBoardRevealUrl: function (){
      this.jobBoardUrlVisiable = true;
      logUserEvent(EVENT_TYPES.REVEAL_JOB_BOARD_URL, {
        [EVENT_PARAMETERS.REVEAL_JOB_BOARD_URL_EVENT_URL]: this.jobOffer.id,
      });
    },
    onViewJobBoardClick: function () {
      logUserEvent(EVENT_TYPES.VIEW_JOB_BOARD_URL, {
        [EVENT_PARAMETERS.VIEW_JOB_BOARD_URL_EVENT_JOB_OFFER]: this.jobOffer.id,
        [EVENT_PARAMETERS.VIEW_JOB_BOARD_URL_EVENT_URL]:
          this.jobOffer.external_url,
      });
      window.open(this.jobOffer.external_url, '_blank');
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../../sass/variables_mixins';
.job-offer-details-card {
  border: 1px solid $phairify_v2_color_primary_teal;
  border-radius: 0;
  font-family: $phairify_font_montserrat;
  .btn-v2_link {
    text-decoration: none;
    color: $phairify_v2_color_primary_navy !important;
    &:hover {
      color: $phairify_v2_color_primary_teal !important;
    }
  }
  &.responsive-font {
    @media (max-width: $tablet-portrait - 1px) {
      font-size: 12px;
    }
    @media (max-width: $laptop - 1px) {
      font-size: 14px;
      line-height: 16px;
    }
  }
}
</style>
